<template>
  <div class="flex">
    <div class="dealInfo_container">
      <div class="flex radio-content">
        <v-radio-group dense outlined row style="margin-top: 1px; margin-bottom: -18px"
          id="selOption" 
          ref="selOption" 
          v-model="selOption"
        >
          <v-radio
            label="입식처" value="enter" color="#005B96" @click="listCompanies() "
          ></v-radio>
          <v-radio
            label="출하처" value="sale" color="#005B96"  @click="listCompanies()"
          ></v-radio>
          <v-radio
            label="도축처" value="slaughter" color="#005B96"  @click="listCompanies()"
          ></v-radio>
          <v-radio
            label="사료" value="feed" color="#005B96"  @click="listCompanies()"
          ></v-radio>
          <v-radio
            label="약품" value="medi" color="#005B96"  @click="listCompanies()"
          ></v-radio>
          <v-radio
            label="방역" value="fumi" color="#005B96"  @click="listCompanies()"
          ></v-radio>
          <v-radio
            label="기타" value="etc" color="#005B96"  @click="listCompanies()"
          ></v-radio>
          <v-radio
            label="모두" value="all" color="#005B96"  @click="listCompanies()"
          ></v-radio>
      </v-radio-group>
      </div>

      <div class="table_layout">
        <v-data-table dense class="table_content" 
          :loading="loadingTable" 
          :headers="headers"
          :items="companies"
          no-data-text="등록된 자료가 없거나 접근 권한이 없습니다."
          id="companies" 
          ref="companies" 
          @click:row="infoDetail"
          item-key="business_no"
          single-select
          :item-class="itemRowBackground"
          fixed-header
          hide-default-footer
          :items-per-page= "500"
          sort-by="company_name"
        />
      </div>
    </div>

    <div class="DealCompany_container">
      <div>
        <v-icon size="24" color="#005B96">mdi-home-assistant</v-icon>
        <span class="info_title">거래처 정보</span>
      </div>

      <div class="info-content">
        <span class="info-tab" v-show="preRegCompany_cd"> {{preRegCompany_cd}} </span>
        <span class="info-tab ml-1" v-show="preBusiness_no"> {{preBusiness_no}} </span>
        
        <div class="mt-3 flex">
          <div class="checkbox-container flex">
            <div class="check-title">거래처 유형 *</div>
            <div class="checkbox-content">
              <div class="flex checkbox">
                <v-checkbox color=#005B96 ref="enter" v-model="ck_enter" label="입식처" ></v-checkbox>
                <v-checkbox color=#005B96 v-model="ck_sale" label="출하처" ></v-checkbox>
                <v-checkbox color=#005B96 v-model="ck_slaughter" label="도축장" ></v-checkbox>
              </div>
              <div class="flex checkbox">
                <v-checkbox color=#005B96 v-model="ck_feed" label="사료" ></v-checkbox>
                <v-checkbox color=#005B96 v-model="ck_medi" label="약품" ></v-checkbox>
                <v-checkbox color=#005B96 v-model="ck_fumi" label="방역" ></v-checkbox>
                <v-checkbox color=#005B96 v-model="ck_etc" label="기타" ></v-checkbox>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-3 flex">
          <v-text-field dense outlined 
            class="textfield"
            :loading = "loading"
            id="company_name" 
            ref="company_name" 
            label="거래처명✽" 
            v-model="company_name" 
          />
          <v-text-field dense outlined
            class="textfield"
            id="business_no" 
            ref="business_no"
            label="사업자/법인 등록번호✽" 
            placeholder="사업자 또는 법인 등록번호의 숫자만 입력"
            v-model="business_no" 
            @keyup="getRegMask(business_no)"
            
          />
        </div>

        <div class="mt-1 flex">
          <v-text-field dense outlined
            class="textfield"
            id="ceo_name" 
            ref="ceo_name" 
            label="대표자명✽" 
            placeholder="대표자 또는 담당자 명"
            v-model="ceo_name" 
          />
          <v-text-field dense outlined 
            class="textfield"
            id="phone" 
            ref="phone" 
            label="전화번호✽" 
            placeholder="숫자만 입력"
            v-model="phone"
            @keyup="getPhoneMask(phone)"
          />
        </div>

        <div class="mt-3">
          <div class="flex">
            <v-text-field dense outlined
              disabled
              class="textfield"
              id="post_no" 
              ref="post_no" 
              label="우편번호✽" 
              v-model="post_no" 
              onKeyup="this.value=this.value.replace(/[^0-9]/g,'');"
              maxlength="5"
            />
            <v-btn text class="search_btn mt-1"
            @click="openPost()">
              검색
            </v-btn>
          </div>

          <div class="mt-1">
            <v-text-field dense outlined
            disabled
            style="min-width:500px;"
            class="textfield"
            id="address_1st" 
            ref="address_1st" 
            label="기본주소✽" 
            v-model="address_1st" 
            />
          </div>
          <div class="mt-1">
            <v-text-field dense outlined 
              style="min-width:500px;"
              class="textfield"
              id="address_last" 
              ref="address_last" 
              label="상세주소(빌딩명,동호수,상호)" 
              v-model="address_last" 
            />
          </div>
        </div>

                
        <div class="mt-2 flex s-bt">
          <v-text-field dense outlined 
            class="textfield"
            id="email_id" 
            ref="email_id" 
            label="이메일" 
            v-model="email_id" 
          />
          <div class="mr-1">
            <img :src="mail" class="mt-5 icon"/>
          </div>
          <v-combobox dense outlined 
            id="email_host" 
            ref="email_host" 
            :items="['gmail.com','hotmail.com','naver.com','daum.net',]"
            :menu-props="{ top: false, offsetY: true }"
            placeholder="항목이 없으면 직접 입력하세요"
            v-model="email_host" 
          />
        </div>

        <div class="mt-4 flex">
          <div>
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field dense outlined 
                  class="picker"
                  id="dealdate" 
                  ref="dealdate" 
                  v-model="dealdate"
                  label="거래시작일✽"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                no-title locale="ko-KR"
                v-model="dealdate"
                @input="menu1 = false"
              ></v-date-picker>
            </v-menu>
          </div>

          <div>
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field dense outlined clearable  class="picker"
                    id="deldate" 
                    ref="deldate" 
                    v-model="deldate"
                    label="거래중지일"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  no-title locale="ko-KR"
                  v-model="deldate"
                  @input="menu2 = false"
                ></v-date-picker>
              </v-menu>
          </div>
        </div>

        <div class="mt-2">
          <v-textarea outlined dense rows="2"
            class="textarea-field"
            label="비고"
            id="history" 
            ref="history" 
            v-model="history"
            value=""
            persistent-hint 
            :hint="hint"
          ></v-textarea>
        </div>

        <div class="mt-10 flex vertical-center">
          <v-btn
            class="normal-btn mr-3"
            text
            :loading="loadingSave"
            id="save" 
            ref="save" 
            type="submit" 
            @click.prevent="save()"
          >
            저장
          </v-btn>
          <v-btn 
            class="new-btn"
            text
            id="newRegister" 
            ref="newRegister" 
            @click="clearData()">
            새로등록
          </v-btn>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
  import Apis from '@/api/apis'
  import Common from "@/utils/custom/common.js";
  import dateUtil from "@/utils/custom/dateProperty.js";

  export default {
    name: 'RegisterDealCompany',

  created() {
    this.listCompanies();
    this.loadDaumPostCode();
  },

  data() {
    return {
      mail: require("@/assets/login/mail.svg"),

      headers: [
        { text: '상호', align: 'left', sortable: true, value: 'company_name'},
        // { text: '전화번호', value: 'phone1'},
        { text: '거래 시작일', value: 'dealdate', sortable: false},
        { text: '거래 중지일', value: 'deldate', sortable: false},
      ],
      companies : [],
      loadingTable: false,

      selOption: "all",
      enter: false,
      sale: false,
      slaughter: false,
      feed: false,
      medi: false,
      fumi: false,
      etc: false,

      selectedBizNo: {},
      // routedBizNo: "",

      bizNO_disabled: true,
      preRegCompany_cd: "",
      preBusiness_no: "",
      
      company_name: "",
      ceo_name: "",
      business_no: "",
      post_no: "",
      ck_enter: false,
      ck_sale: false,
      ck_slaughter: false,
      ck_feed: false,
      ck_medi: false,
      ck_fumi: false,
      ck_etc: false,
      address_1st: "",
      address_last: "",
      email_id: "",
      email_host: "",
      phone: "",
      dealdate: "",
      deldate: "",
      history: "",
      hint: "",
      
      // businessDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu1: false,
      menu2: false,

      loading: false,
      loadingSave: false,

    }
  },
  methods: {
    loadDaumPostCode() {
      if (!window.daum) {
        const script = document.createElement('script');
        script.src = '//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
        script.async = true;
        document.head.appendChild(script);
      }
    },
    openPost() {
      // daum이 로드되었는지 확인 후 실행
      if (window.daum && window.daum.Postcode) {
        new daum.Postcode({
          oncomplete: (data) => {
            // 검색결과 항목을 클릭했을 때 실행할 코드
            this.post_no = data.zonecode;
            this.address_1st = data.roadAddress;
          },
        }).open();
      } else {
        console.error('Daum Postcode API is not loaded yet');
      }
    },
    listCompanies() {
      this.$store.commit("resMessage","");
      this.loadingTable = true;
      Apis.listDealCompanies({
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"),
        dealtype: this.selOption,
      } ,(res) => {  // 정상처리
        // console.log("res",res);
        res.data.forEach(element => {
          element.business_no = Common.getRegMask(element.business_no);
          element.phone1 = Common.getMask(element.phone1);
          element.address_1st = element.address_1st + "" + element.address_last
          element.service = element.service == "5" ? "프리미엄" : "일반" ;
        });
        this.companies = res.data;
        this.$store.commit("resMessage",res.message);
        this.loadingTable = false;
      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("listCompanies 호출 오류",err);
        this.$router.push("/");
        this.loadingTable = false;
      }) 
    },
    itemRowBackground(item) {
      return item.business_no == this.business_no  ? 'selected' : '' ;
    },
    clearData() {
      this.bizNO_disabled = true;
      this.preRegCompany_cd = "",
      this.preBusiness_no = "";
      this.business_no = "";
      this.company_name = "";
      this.ceo_name = "";
      this.ck_enter = false,
      this.ck_sale = false,
      this.ck_slaughter = false,
      this.ck_feed = false,
      this.ck_medi = false,
      this.ck_fumi = false,
      this.ck_etc = false,
      this.post_no = "";
      this.address_1st = "";
      this.address_last = "";
      this.email_id = "";
      this.email_host = "";
      this.phone = "";
      this.dealdate = "";
      this.deldate = "";
      this.history = "";
      this.hint = "";
    },
    checkData() {
      if (!this.company_name.trim()) {
        this.$refs.company_name.focus();
        return "거래처명을 입력하세요";
      }
      if (!this.business_no) {
        this.$refs.business_no.focus();
        return "사업자/법인 등록번호를 입력하세요";
      }
      if (!(Common.checkBizNo(this.business_no)) && !(Common.checkRegNo(this.business_no))) {
        this.$refs.business_no.focus();
        return "사업자/법인 등록번호가 틀렸습니다.";
      }  
      if (!this.ck_enter && !this.ck_sale && !this.ck_slaughter && !this.ck_feed && !this.ck_medi && !this.ck_fumi && !this.ck_etc ) {
        this.$refs.business_no.focus();
        return "거래유형중 하나 이상을 선택하세요";
      }
      if (!this.post_no) {
        this.$refs.post_no.focus();
        return "우편번호를 입력하세요";
      }
      if (!this.address_1st.trim()) {
        this.$refs.address_1st.focus();
        return "기본주소를 입력하세요";
      }
      if (!this.phone.trim()) {
        this.$refs.phone.focus();
        return "전화번호를 입력하세요";
      }
      if (!this.dealdate) {
        this.$refs.dealdate.focus();
        return "거래시작일을 입력하세요";
      }
      return "";
    },
    save() {
      // console.log("checkdata", this.checkData());
      this.$store.commit("resMessage","");

      let msgCheckdata = this.checkData(); 
      if (msgCheckdata){
        this.$store.commit("resMessage",msgCheckdata);
        // alert(msgCheckdata);
        return;
      }
      this.loadingSave = true;
      if (this.preBusiness_no) {
        // console.log("업데이트");
        Apis.updateDealCompany({
          regcompany_cd: this.preRegCompany_cd,
          business_no: this.preBusiness_no,
          company_name: this.company_name.trim(),
          ceo_name: this.ceo_name.trim(),
          enter: this.ck_enter ?  "Y" : "",
          sale: this.ck_sale ?  "Y" : "",
          slaughter: this.ck_slaughter ?  "Y" : "",
          feed: this.ck_feed ?  "Y" : "",
          medi: this.ck_medi ?  "Y" : "",
          fumi: this.ck_fumi ?  "Y" : "",
          etc: this.ck_etc ?  "Y" : "",
          post_no: this.post_no,
          address_1st: this.address_1st.trim(),
          address_last: this.address_last.trim(),
          email1: this.email_id.trim() + "@" + this.email_host, 
          email2: "",
          phone1: this.phone.replace(/[^0-9]/g, ''),
          phone2: "",
          dealdate: this.dealdate,
          deldate: this.deldate,
          history: this.history.trim(),
          etc1: "",
          etc2: "",
          etc3: "", 
          },(res) => {  
            if (res.result) {
              this.$store.commit("resMessage",res.message);
              this.loadingSave = false;
              // console.log("selOtion=>",this.$route.params.selOption);
              // this.$router.push({
              //           name: "ListDealCompanies",
              //           params: { business_no: this.business_no, selOption: this.$route.params.selOption}
              // });
              this.clearData();
            } else {
              this.loadingSave = false;
              alert(res.message);
            }
          }).catch( (err) => {  // API 오류 처리
              this.loadingSave = false;
              console.log("API 호출 오류")
              alert(err);
              // console.log(err)
          }
        )
      } else {
        // console.log("인서트",this.email_host.trim());
        Apis.insertDealCompany({
          company_name: this.company_name.trim(),
          ceo_name: this.ceo_name.trim(),
          business_no: this.business_no.replace(/[^0-9]/g, ''),
          enter: this.ck_enter ?  "Y" : "",
          sale: this.ck_sale ?  "Y" : "",
          slaughter: this.ck_slaughter ?  "Y" : "",
          feed: this.ck_feed ?  "Y" : "",
          medi: this.ck_medi ?  "Y" : "",
          fumi: this.ck_fumi ?  "Y" : "",
          etc: this.ck_etc ?  "Y" : "",
          post_no: this.post_no,
          address_1st: this.address_1st.trim(),
          address_last: this.address_last.trim(),
          email1: this.email_id.trim() + "@" + this.email_host, 
          email2: "",
          phone1: this.phone.replace(/[^0-9]/g, ''),
          phone2: "",
          dealdate: this.dealdate,
          deldate: this.deldate,
          history: this.history.trim(),
          etc1: "",
          etc2: "",
          etc3: "", 
          },(res) => {  
            if (res.result) {
              // 정상 등록
              this.$store.commit("resMessage",res.message);
              this.loadingSave = false;
              this.clearData();
            // } else if (res.resultCode == "E124") {
            //     // 등록번호 중복
            //     if (confirm(res.message + "기 등록된 사업자에 거래유형을 추가 하시렵니까?")) {
            //       this.infoDetail({company_cd: res.data.regcompany_cd, business_no: res.data.business_no});
            //       this.loadingSave = false;
            //       return;
            //     } else {
            //       this.loadingSave = false;
            //       return;
            //     }
            } else
              this.loadingSave = false;
              alert(res.message);
          }).catch( (err) => {  // API 오류 처리
              this.loadingSave = false;
              console.log("API 호출 오류")
              alert(err);
              // console.log(err)
          }
        )
      }
    },
    infoDetail(code,row) {
      // console.log(code)
      row && row.select(true);

      this.$store.commit("resMessage","");
      this.loading = true;
      this.clearData();

      const BusinessNo = code.business_no.replace(/-/g, "");

      Apis.infoDealCompany({
        company_cd: code.regcompany_cd, 
        business_no: BusinessNo, 
        },(res) => {  
          // console.log(res)

          if (res.result) {
            this.preRegCompany_cd = code.company_cd;
            this.preBusiness_no = code.business_no;

            this.company_name = res.data.company_name;
            this.business_no = res.data.business_no;
            this.ceo_name = res.data.ceo_name;
            this.ck_enter = res.data.enter && res.data.enter == "Y" ?  true : false;
            this.ck_sale = res.data.sale && res.data.sale == "Y" ?  true : false;
            this.ck_slaughter = res.data.slaughter && res.data.slaughter == "Y" ?  true : false;
            this.ck_feed = res.data.feed && res.data.feed == "Y" ?  true : false;
            this.ck_medi = res.data.medi && res.data.medi == "Y" ?  true : false;
            this.ck_fumi = res.data.fumi && res.data.fumi == "Y" ?  true : false;
            this.ck_etc = res.data.etc && res.data.etc == "Y" ?  true : false;
            this.business_no = Common.getRegMask(res.data.business_no);
            this.post_no = res.data.post_no;
            this.address_1st = res.data.address_1st;
            this.address_last = res.data.address_last;
            this.phone = Common.getMask(res.data.phone1);
            this.enter = res.data.enter == "Y" ? true : false;
            this.dealdate = res.data.dealdate;
            this.deldate = res.data.deldate;
            this.history = res.data.history;
            this.hint = res.data.regdate + "에 등록, " + res.data.chguser + "님이 " + res.data.chgdate + "에 최종 수정";
            this.loading = false;
            
            this.$store.commit("resMessage",res.message);
          } else {
            this.loading = false;
            alert(res.message);
          }
        }).catch( (err) => {  // API 오류 처리
            console.log("API 호출 오류")
            this.loading = false;
            alert(err);
            // console.log(err)
        }
      ) 
    },
    getPhoneMask(val) {
      this.phone = Common.getMask(val)
    },
    getRegMask(val) {
      // let res = Common.getRegMask(val)
      this.business_no = Common.getRegMask(val)
    },
    },  // -----------methods 
  }
</script>

<style lang="scss" scoped>
@import '../info_style/info_style.scss';
.dealInfo_container{
  max-width:550px;
  width:35vw;
}
.radio-content{
  margin-left:10px;
  max-width:400px !important;
  height:45px;
}
.table_content{
  // height:500px !important;
  height:72vh;
}
.info-content{
  margin-left:10px;
  height:710px;
}
.check-title{
  font-weight:600; 
  color:rgba(0, 0, 0, 0.6);
  font-size:15px;
}
.checkbox ::v-deep .v-label {
  width: 55px; /* 공통 너비 */
}
::v-deep .v-radio .v-label {
  width:50px;
}
.checkbox-container{
  align-items: center;
  border:1px solid #e5e5e5;
  height:70px;
  padding:10px;
  border-radius: 15px;
}
.checkbox-content{
  margin-top:-50px;
  margin-left:20px;
}
.checkbox{
  height:35px;
}
.icon{
  width:15px !important;
  height:15px !important;
}
.picker{
  width:250px !important;
}
</style>